import React, {Component} from 'react'
import Report from '../../Report/Report'
import './SecondInputModule.sass'

class SecondInputModule extends Component {
  componentDidMount() {
    const values = JSON.parse(localStorage.getItem('InputParams2')) || false
    const $paramsForm = document.querySelector('.params-form')

    if (values) {
      $paramsForm.typePol.value = values.typePol
        $paramsForm.quality.value = values.quality
        $paramsForm.roughness.value = values.roughness
        $paramsForm.length.value = values.length
        $paramsForm.width.value = values.width
    }

  }

  qualityHandler = event => {
    const $paramsForm = document.querySelector('.params-form')
    if (+event.target.value === 6) {
      $paramsForm.roughness.value = 'Ra0,15'
    }
    if (+event.target.value === 7) {
      $paramsForm.roughness.value = 'Ra0,32'
    }
    if (+event.target.value === 8) {
      $paramsForm.roughness.value = 'Ra0,63'
    }
  }

  saveInputtedValue2 = event => {
    const $paramsForm = document.querySelector('.params-form')
    localStorage.setItem('InputParams2', JSON.stringify({
      typePol: $paramsForm.typePol.value,
      quality: $paramsForm.quality.value,
      roughness: $paramsForm.roughness.value,
      length: $paramsForm.length.value,
      width: $paramsForm.width.value,
    }))
  }

  render() {
    return (
      <React.Fragment>
        <main className='params'>

          <h1 className='params__title'>Ввод Параметров обработки</h1>

          <form className='params-form' action="/action">
            <div className='params-content'>
              <div className="secondInput">
                <div className="params-content-descr">
                  <div className="params-label second-input">
                    <label
                      className="params-label__item"
                      htmlFor="typePol">Вид шлифования</label>
                    <select
                      name='typePol'
                      className="params-label__value"
                      id="typePol">
                      <option value="периферией круга">периферией круга</option>
                      <option value="торцем круга">торцем круга</option>
                    </select>
                  </div>
                  <div className="params-label second-input">
                    <label
                      className="params-label__item"
                      htmlFor="quality">Квалитет точности обработки</label>
                    <select
                      onChange={this.qualityHandler}
                      name='quality'
                      className="params-label__value"
                      id="quality">
                      <option value="8">8</option>
                      <option value="7">7</option>
                      <option value="6">6</option>
                    </select>
                  </div>
                  <div className="params-label second-input">
                    <label
                      className="params-label__item"
                      htmlFor="quality">Шероховатость</label>
                    <select
                      name='roughness'
                      className="params-label__value"
                      id="roughness"
                      disabled
                    >
                      <option value='Ra0,63'>Ra0,63</option>
                      <option value='Ra0,32'>Ra0,32</option>
                      <option value='Ra0,15'>Ra0,15</option>
                    </select>
                  </div>
                  <div className="params-label second-input">
                    <label
                      className="params-label__item"
                      htmlFor="length">Длина обработки, мм</label>
                    <input
                      type='number'
                      defaultValue='3'
                      name='length'
                      className="params-label__value"
                      id="length"/>
                  </div>
                  <div className="params-label second-input">
                    <label
                      className="params-label__item"
                      htmlFor="quality">Ширина обработки, мм</label>
                    <input
                      type='number'
                      defaultValue='3'
                      name='width'
                      className="params-label__value"
                      id="width"/>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </main>
        <Report showSave={true} onClick={this.saveInputtedValue2}/>
      </React.Fragment>
    )
  }
}

export default SecondInputModule